import ModalImage from './ModalImage'

export default ModalImage
